import React from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    ButtonBase,
    IconButton,
    Tooltip,
    Snackbar,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
    FaYoutube,
    FaTwitch,
    FaTelegramPlane,
    FaDiscord,
    FaInstagram,
} from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import {showErrorToast, showInfoToast, showSuccessToast} from "../Visuals/ToastNotification";
import {ToastContainer} from "react-toastify";

const CONTACTS = [
    {
        key: "youtube",
        label: "YouTube",
        value: "https://www.youtube.com/@verum_t",
        icon: <FaYoutube />,
        bg: "rgba(220, 38, 38, 0.35)",
    },
    {
        key: "twitch",
        label: "Twitch",
        value: "https://www.twitch.tv/verumt",
        icon: <FaTwitch />,
        bg: "rgba(168, 85, 247, 0.35)",
    },
    {
        key: "telegram",
        label: "Telegram",
        value: "https://t.me/verumt",
        icon: <FaTelegramPlane />,
        bg: "rgba(14, 165, 233, 0.35)",
    },
    {
        key: "discord",
        label: "Discord",
        value: "https://discord.gg/Br7dQmWvnC",
        icon: <FaDiscord />,
        bg: "rgba(99, 102, 241, 0.35)",
    },
    {
        key: "instagram",
        label: "Instagram",
        value: "https://www.instagram.com/verumt",
        icon: <FaInstagram />,
        bg: "rgba(244, 63, 94, 0.35)",
    },
    {
        key: "gmail",
        label: "Для рекламодавців:",
        value: "verum397@gmail.com",
        copyValue: "verum397@gmail.com",
        icon: <SiGmail />,
        bg: "rgba(245, 158, 11, 0.35)",
    },
];

const Contacts = () => {

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            showSuccessToast("Скопійовано!");
        } catch {
            showErrorToast("Не вдалося скопіювати");
        }
    };

    const handleRowClick = (item) => {
        const toCopy = item.copyValue ?? item.value;
        copyToClipboard(toCopy);
    };

    return (
        <Box
            sx={{
                minHeight: "calc(100vh - 56px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
                py: 6,
            }}
        >
            <ToastContainer/>
            <Card
                sx={{
                    width: "100%",
                    maxWidth: 520,
                    borderRadius: "18px",
                    background: "rgba(10, 14, 28, 0.55)",
                    border: "1px solid rgba(255,255,255,0.10)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 18px 40px rgba(0,0,0,0.35)",
                    overflow: "hidden",
                }}
            >
                <CardContent sx={{ p: 3 }}>
                    <Typography variant="h5" sx={{ color: "#fff", fontWeight: 700, textAlign: "center", paddingBottom: 2 }}>
                        Мої соц.мережі
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                        {CONTACTS.map((item) => (
                            <Box
                                key={item.key}
                                sx={{
                                    position: "relative",
                                    borderRadius: "14px",
                                    overflow: "hidden",
                                    border: "1px solid rgba(255,255,255,0.10)",
                                    background: item.bg,
                                }}
                            >
                                <ButtonBase
                                    onClick={() => handleRowClick(item)}
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        px: 1.6,
                                        py: 1.3,
                                        transition: "transform 160ms ease, filter 160ms ease",
                                        "&:hover": {
                                            transform: "scale(1.02)",
                                            filter: "brightness(1.08)",
                                        },
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
                                        <Box
                                            sx={{
                                                width: 42,
                                                height: 42,
                                                borderRadius: "12px",
                                                display: "grid",
                                                placeItems: "center",
                                                background: "rgba(0,0,0,0.25)",
                                                color: "#fff",
                                                fontSize: 22,
                                            }}
                                        >
                                            {item.icon}
                                        </Box>

                                        <Box sx={{ textAlign: "left" }}>
                                            <Typography sx={{ color: "#fff", fontWeight: 700 }}>
                                                {item.label}
                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                sx={{ color: "rgba(255,255,255,0.78)" }}
                                            >
                                                {item.copyValue ?? item.value}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                        <Tooltip title="Copy">
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    copyToClipboard(item.copyValue ?? item.value);
                                                }}
                                                size="small"
                                                sx={{ color: "rgba(255,255,255,0.85)" }}
                                            >
                                                <ContentCopyIcon fontSize="inherit" />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Open">
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    window.open(item.value, "_blank", "noopener,noreferrer");
                                                }}
                                                size="small"
                                                sx={{ color: "rgba(255,255,255,0.85)" }}
                                            >
                                                <OpenInNewIcon fontSize="inherit" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </ButtonBase>
                            </Box>
                        ))}
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Contacts;
